import { jsx } from "react/jsx-runtime";
import { Modal } from "../private/Modal/Modal.mjs";
import "../private/Modal/ModalContent.mjs";
import { ModalProvider } from "../private/Modal/ModalContext.mjs";
const defaultWidth = "small";
const modalStyle = {
  position: "center",
  headingLevel: "6"
};
const Dialog = ({ width = defaultWidth, ...restProps }) => /* @__PURE__ */ jsx(ModalProvider, { children: /* @__PURE__ */ jsx(Modal, { width, ...restProps, ...modalStyle }) });
export {
  Dialog
};
